import type { ISaleRepository, UpdateSaleInput } from '../repositories/ISaleRepository.js';

export function createUpdateSaleUseCase(deps: { saleRepository: ISaleRepository }) {
  return async function updateSaleUseCase(saleId: string, input: UpdateSaleInput): Promise<boolean> {
    return deps.saleRepository.updateSale(saleId, input);
  };
}

export type UpdateSaleUseCase = ReturnType<typeof createUpdateSaleUseCase>;
